import { environment } from './environments/environment';
import { Injectable } from '@angular/core';
import { AppStorageService } from './app/share/appstorage.service';

import { registerLocaleData } from '@angular/common';
import localeSqXk from '@angular/common/locales/sq-XK';
import localeSqXkExtra from '@angular/common/locales/extra/sq-XK';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
import localeHr from '@angular/common/locales/hr';
import localeEs from '@angular/common/locales/es';
import localeEsCo from '@angular/common/locales/es-CO';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeEsCoExtra from '@angular/common/locales/extra/es-CO';
import localeHrExtra from '@angular/common/locales/extra/hr';
import localeFrExtra from '@angular/common/locales/extra/hr';
import localeSerbian from '@angular/common/locales/sr-Cyrl';
import localeSerbianExtra from '@angular/common/locales/extra/sr-Cyrl';


@Injectable()
export class AppSettings {
    public production = environment.production;
    public apiUrl: string = environment.apiUrl;
    public defaultLanguage = 'en';
    public defaultLocale = environment.defaultLocale;
    public defaultCurrency = 'EUR';
    public defaultCurrencySuffix = ' €';
    public recordsPerPage = environment.recordsPerPage;
    public onlineConnectionStatusColor = '#76ce4b';
    public offlineConnectionStatusColor = '#ff471a';
    public unknownConnectionStatusColor = '#ffad33';
    public defaultCurrencySuffixAfterCutoverDate = environment.defaultCurrencySuffixAfterCutoverDate;
    public currencyCutoverDate: Date = new Date(environment.currencyCutoverDate+" 00:00:00");

    constructor(
        private _appStorageService: AppStorageService
    ) {
        this.setLanguageAndCurrency(this.defaultLocale);
    }

    getLocale(): string {
        return this.defaultLocale;
    }

    public setLanguageAndCurrency(defaultLocale: string) {
        switch (defaultLocale) {
            case 'sr-RS':
                this.defaultCurrency = 'дин.';
                this.defaultCurrencySuffix = ' дин.';
                this.defaultLanguage = 'sr';
                break;
            case 'hr-HR':
                this.defaultCurrency = 'HRK';
                this.defaultCurrencySuffix = ' kn';
                this.defaultLanguage = 'hr';
                break;
            case 'en-EN':
                this.defaultCurrency = 'USD';
                this.defaultCurrencySuffix = ' €';
                this.defaultLanguage = 'en';
                break;
            case 'sq-XK':
                this.defaultCurrency = 'EUR';
                this.defaultCurrencySuffix = ' €';
                this.defaultLanguage = 'sq';
        }

        switch (defaultLocale) {
            case 'fr-FR':
                registerLocaleData(localeFr, 'fr', localeFrExtra);
                break;
            case 'en-EN':
                registerLocaleData(localeEn, 'en', localeEnExtra);
                break;
            case 'es':
                registerLocaleData(localeEs, 'es', localeEsExtra);
                break;
            case 'es-CO':
                registerLocaleData(localeEsCo, 'es-CO', localeEsExtra);
                break;
            case 'hr-HR':
                registerLocaleData(localeHr, 'hr', localeHrExtra);
                break;
            case 'sq-XK':
                registerLocaleData(localeSqXk, 'sq-XK', localeSqXkExtra);
                break;
            case 'sr-RS':
                registerLocaleData(localeSerbian, 'sr-RS', localeSerbianExtra);
                break;
        }
    }

    setLanguageToAppStorage(lang: string) {
        this._appStorageService.setAppsLang(lang);
    }
    
    getCurrencySuffix(date: Date){
        if(this.currencyCutoverDate != null && date >= this.currencyCutoverDate)
            return this.defaultCurrencySuffixAfterCutoverDate;
        else
            return this.defaultCurrencySuffix;
    }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/settings.ts